<template>
  <div class="contenedor-paginador" id ="paginador-productos-investigacion">
    <div class="numerador">
      <button class="numerador-item" @click="$emit('cambiarPagina', 0)">&laquo;</button>

      <button class="numerador-item" @click="$emit('cambiarPagina', 
        paginaActual>0? paginaActual-1: 0)">‹</button>
      <div class="contenedor-item">
        <div class="botones-numericos">
          <button class="numerador-item"
            v-for="numeroPagina of rango(nPaginas)"
            :key="`numerador_item_${numeroPagina}`"
            v-bind:class="{'actual': numeroPagina===paginaActual}"
            @click="$emit('cambiarPagina', numeroPagina)"
            >{{ numeroPagina+1 }}</button>
        </div>
      </div>
      
      <button class="numerador-item penultima" @click="$emit('cambiarPagina', 
          (paginaActual+1)<nPaginas? paginaActual+1: nPaginas-1)">›</button>
      <button class="numerador-item" @click="$emit('cambiarPagina', nPaginas-1)">&raquo;</button>
    </div>
  </div>
</template>

<script>
export default {
  mounted(){
    window.addEventListener("resize", this.reescalacion);
  },
  props: {
    nPaginas: {
      type: Number,
      default: 2,
    },
    paginaActual: {
      type: Number,
      default: 0,
    },
  },
  watch:{
    paginaActual(nv){
      this.paginadorNumericoMovil();
    }
  },
  methods: {
    rango(inicio, fin=undefined) {
      if (fin===undefined) {
        fin = inicio
        return Array(fin).fill().map((_, i) => i)
      }
      return Array(fin - inicio + 1).fill().map((_, i) => inicio + i)
    },
    paginadorNumericoMovil(){
      let paginador_numeros = document
          .querySelector("#paginador-productos-investigacion .botones-numericos")
      if(this.paginaActual <= 2 && window.innerWidth < 619 ){
        paginador_numeros
          .style
          .left = `${0}px`
        paginador_numeros
          .style
          .float = `left`
      } 
      else if(this.paginaActual > 2 && window.innerWidth < 619 && this.paginaActual < 6 ){
        paginador_numeros
          .style
          .left = `${-(this.paginaActual - 2) * 40}px`
        paginador_numeros
          .style
          .float = `left`
      }
      else if( window.innerWidth < 619 && this.paginaActual >= 6 ){
        paginador_numeros
          .style
          .left = `0px`
        paginador_numeros
          .style
          .float = `right`
      }
    },
    reescalacion(){
      if(window.innerWidth < 619){
        this.paginadorNumericoMovil();
      }
      else{
        let paginador_numeros = document
          .querySelector("#paginador-productos-investigacion .botones-numericos")
        paginador_numeros
          .style
          .left = `${0}px`
        paginador_numeros
          .style
          .float = `left`
      }
    },


  },
}
</script>

<style scoped lang="scss">
.contenedor-paginador {
  margin: 1em;
  display: flex;
  justify-content: center;
  .numerador {
    display: flex;
    flex-wrap: nowrap;
    background-color: white;
    border: 2px solid #141414;
    border-radius: 10px;
    height: 40px;
    max-width: 524px;
    width: 100%;
    .numerador-item {
      cursor: pointer;
      height: 100%;
      background-color: white;
      color: black;
      border: none;
      border-radius: 0;
      margin-right: 0;
      width: 40px;
      &.actual, &:hover {
        background-color: black;
        color: white;
        font-weight: bold;
      }
      &:not(:last-child) {
        border-right: 2px solid #141414;
      }
      &:first-child {
        border-top-left-radius: 10px;
        border-bottom-left-radius: 10px;
      }
      &:last-child {
        border-top-right-radius: 10px;
        border-bottom-right-radius: 10px;
        //border-left: 2px solid #141414;
      }
      &.penultima{
        border-left: 2px solid #141414;
      }
    }
    .contenedor-item{
      max-width: calc(100% - 160px );
      overflow: hidden;
      .botones-numericos{
        display: flex;
        position: relative;
        left: 0;
        overflow: auto;
        width: 360px;
        height: 36px;
        .numerador-item {

          &:first-child {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
          }
          &:last-child {
            border-top-right-radius: 0;
            border-bottom-right-radius: 0;
            //border-right: 2px solid #141414;
          }
          

        }
      }
    }
    
  }
}
</style>